import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { LOCALES, get } from "./translations";

const I18nContext = createContext(null);
const STORAGE_KEY = "ojavana.locale";

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && LOCALES.some((l) => l.code === saved)) return saved;
    const browser = (window.navigator?.language || "en").slice(0, 2).toLowerCase();
    return LOCALES.some((l) => l.code === browser) ? browser : "en";
  });

  const setLocale = useCallback((code) => {
    setLocaleState(code);
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, code);
      document.documentElement.setAttribute("lang", code);
    }
  }, []);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", locale);
    }
  }, [locale]);

  const t = useCallback((path, fallback = "") => get(locale, path, fallback), [locale]);

  const value = useMemo(() => ({ locale, setLocale, t, locales: LOCALES }), [locale, setLocale, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
